import { GrowthDataSet } from '../../types/data-set.types';

export const whoBoysHeadCircumferenceMonthly: GrowthDataSet = {
  id: 'who-boys-head-circumference-monthly-0-5',
  source: 'WHO',
  title: 'Head circumference-for-age',
  intervalType: 'month',
  gender: 'male',
  measurementType: 'head_circumference',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 34.4618,
      s: 0.03686,
      sd: 1.2703,
      percentiles: {
        p1: 31.5,
        p3: 32.1,
        p5: 32.4,
        p15: 33.1,
        p25: 33.6,
        p50: 34.5,
        p75: 35.3,
        p85: 35.8,
        p95: 36.6,
        p97: 36.9,
        p99: 37.4,
      },
    },
    {
      age: 1,
      m: 37.2759,
      s: 0.03133,
      sd: 1.1679,
      percentiles: {
        p1: 34.6,
        p3: 35.1,
        p5: 35.4,
        p15: 36.1,
        p25: 36.5,
        p50: 37.3,
        p75: 38.1,
        p85: 38.5,
        p95: 39.2,
        p97: 39.5,
        p99: 40,
      },
    },
    {
      age: 2,
      m: 39.1285,
      s: 0.02997,
      sd: 1.1727,
      percentiles: {
        p1: 36.4,
        p3: 36.9,
        p5: 37.2,
        p15: 37.9,
        p25: 38.3,
        p50: 39.1,
        p75: 39.9,
        p85: 40.3,
        p95: 41.1,
        p97: 41.3,
        p99: 41.9,
      },
    },
    {
      age: 3,
      m: 40.5135,
      s: 0.02918,
      sd: 1.1822,
      percentiles: {
        p1: 37.8,
        p3: 38.3,
        p5: 38.6,
        p15: 39.3,
        p25: 39.7,
        p50: 40.5,
        p75: 41.3,
        p85: 41.7,
        p95: 42.5,
        p97: 42.7,
        p99: 43.3,
      },
    },
    {
      age: 4,
      m: 41.6317,
      s: 0.02868,
      sd: 1.194,
      percentiles: {
        p1: 38.9,
        p3: 39.4,
        p5: 39.7,
        p15: 40.4,
        p25: 40.8,
        p50: 41.6,
        p75: 42.4,
        p85: 42.9,
        p95: 43.6,
        p97: 43.9,
        p99: 44.4,
      },
    },
    {
      age: 5,
      m: 42.5576,
      s: 0.02837,
      sd: 1.2074,
      percentiles: {
        p1: 39.7,
        p3: 40.3,
        p5: 40.6,
        p15: 41.3,
        p25: 41.7,
        p50: 42.6,
        p75: 43.4,
        p85: 43.8,
        p95: 44.5,
        p97: 44.8,
        p99: 45.4,
      },
    },
    {
      age: 6,
      m: 43.3306,
      s: 0.02817,
      sd: 1.2206,
      percentiles: {
        p1: 40.5,
        p3: 41,
        p5: 41.3,
        p15: 42.1,
        p25: 42.5,
        p50: 43.3,
        p75: 44.2,
        p85: 44.6,
        p95: 45.3,
        p97: 45.6,
        p99: 46.2,
      },
    },
    {
      age: 7,
      m: 43.9803,
      s: 0.02804,
      sd: 1.2332,
      percentiles: {
        p1: 41.1,
        p3: 41.7,
        p5: 42,
        p15: 42.7,
        p25: 43.1,
        p50: 44,
        p75: 44.8,
        p85: 45.3,
        p95: 46,
        p97: 46.3,
        p99: 46.8,
      },
    },
    {
      age: 8,
      m: 44.53,
      s: 0.02796,
      sd: 1.2451,
      percentiles: {
        p1: 41.6,
        p3: 42.2,
        p5: 42.5,
        p15: 43.2,
        p25: 43.7,
        p50: 44.5,
        p75: 45.4,
        p85: 45.8,
        p95: 46.6,
        p97: 46.9,
        p99: 47.4,
      },
    },
    {
      age: 9,
      m: 44.9998,
      s: 0.02792,
      sd: 1.2564,
      percentiles: {
        p1: 42.1,
        p3: 42.6,
        p5: 42.9,
        p15: 43.7,
        p25: 44.2,
        p50: 45,
        p75: 45.8,
        p85: 46.3,
        p95: 47.1,
        p97: 47.4,
        p99: 47.9,
      },
    },
    {
      age: 10,
      m: 45.4051,
      s: 0.0279,
      sd: 1.2668,
      percentiles: {
        p1: 42.5,
        p3: 43,
        p5: 43.3,
        p15: 44.1,
        p25: 44.6,
        p50: 45.4,
        p75: 46.3,
        p85: 46.7,
        p95: 47.5,
        p97: 47.8,
        p99: 48.4,
      },
    },
    {
      age: 11,
      m: 45.7573,
      s: 0.02789,
      sd: 1.2762,
      percentiles: {
        p1: 42.8,
        p3: 43.4,
        p5: 43.7,
        p15: 44.4,
        p25: 44.9,
        p50: 45.8,
        p75: 46.6,
        p85: 47.1,
        p95: 47.9,
        p97: 48.2,
        p99: 48.7,
      },
    },
    {
      age: 12,
      m: 46.0661,
      s: 0.02789,
      sd: 1.2848,
      percentiles: {
        p1: 43.1,
        p3: 43.6,
        p5: 44,
        p15: 44.7,
        p25: 45.2,
        p50: 46.1,
        p75: 46.9,
        p85: 47.4,
        p95: 48.2,
        p97: 48.5,
        p99: 49.1,
      },
    },
    {
      age: 13,
      m: 46.3395,
      s: 0.02789,
      sd: 1.2924,
      percentiles: {
        p1: 43.3,
        p3: 43.9,
        p5: 44.2,
        p15: 45,
        p25: 45.5,
        p50: 46.3,
        p75: 47.2,
        p85: 47.7,
        p95: 48.5,
        p97: 48.8,
        p99: 49.3,
      },
    },
    {
      age: 14,
      m: 46.5844,
      s: 0.02791,
      sd: 1.3002,
      percentiles: {
        p1: 43.6,
        p3: 44.1,
        p5: 44.4,
        p15: 45.2,
        p25: 45.7,
        p50: 46.6,
        p75: 47.5,
        p85: 47.9,
        p95: 48.7,
        p97: 49,
        p99: 49.6,
      },
    },
    {
      age: 15,
      m: 46.806,
      s: 0.02792,
      sd: 1.3068,
      percentiles: {
        p1: 43.8,
        p3: 44.3,
        p5: 44.7,
        p15: 45.5,
        p25: 45.9,
        p50: 46.8,
        p75: 47.7,
        p85: 48.2,
        p95: 49,
        p97: 49.3,
        p99: 49.8,
      },
    },
    {
      age: 16,
      m: 47.0088,
      s: 0.02795,
      sd: 1.3139,
      percentiles: {
        p1: 44,
        p3: 44.5,
        p5: 44.8,
        p15: 45.6,
        p25: 46.1,
        p50: 47,
        p75: 47.9,
        p85: 48.4,
        p95: 49.2,
        p97: 49.5,
        p99: 50.1,
      },
    },
    {
      age: 17,
      m: 47.1962,
      s: 0.02797,
      sd: 1.3201,
      percentiles: {
        p1: 44.1,
        p3: 44.7,
        p5: 45,
        p15: 45.8,
        p25: 46.3,
        p50: 47.2,
        p75: 48.1,
        p85: 48.6,
        p95: 49.4,
        p97: 49.7,
        p99: 50.3,
      },
    },
    {
      age: 18,
      m: 47.3711,
      s: 0.028,
      sd: 1.3264,
      percentiles: {
        p1: 44.3,
        p3: 44.9,
        p5: 45.2,
        p15: 46,
        p25: 46.5,
        p50: 47.4,
        p75: 48.3,
        p85: 48.7,
        p95: 49.6,
        p97: 49.9,
        p99: 50.5,
      },
    },
    {
      age: 19,
      m: 47.5357,
      s: 0.02803,
      sd: 1.3324,
      percentiles: {
        p1: 44.4,
        p3: 45,
        p5: 45.3,
        p15: 46.2,
        p25: 46.6,
        p50: 47.5,
        p75: 48.4,
        p85: 48.9,
        p95: 49.7,
        p97: 50,
        p99: 50.6,
      },
    },
    {
      age: 20,
      m: 47.6919,
      s: 0.02806,
      sd: 1.3382,
      percentiles: {
        p1: 44.6,
        p3: 45.2,
        p5: 45.5,
        p15: 46.3,
        p25: 46.8,
        p50: 47.7,
        p75: 48.6,
        p85: 49.1,
        p95: 49.9,
        p97: 50.2,
        p99: 50.8,
      },
    },
    {
      age: 21,
      m: 47.8408,
      s: 0.0281,
      sd: 1.3443,
      percentiles: {
        p1: 44.7,
        p3: 45.3,
        p5: 45.6,
        p15: 46.4,
        p25: 46.9,
        p50: 47.8,
        p75: 48.7,
        p85: 49.2,
        p95: 50.1,
        p97: 50.4,
        p99: 51,
      },
    },
    {
      age: 22,
      m: 47.9833,
      s: 0.02813,
      sd: 1.3498,
      percentiles: {
        p1: 44.8,
        p3: 45.4,
        p5: 45.8,
        p15: 46.6,
        p25: 47.1,
        p50: 48,
        p75: 48.9,
        p85: 49.4,
        p95: 50.2,
        p97: 50.5,
        p99: 51.1,
      },
    },
    {
      age: 23,
      m: 48.1201,
      s: 0.02817,
      sd: 1.3555,
      percentiles: {
        p1: 45,
        p3: 45.6,
        p5: 45.9,
        p15: 46.7,
        p25: 47.2,
        p50: 48.1,
        p75: 49,
        p85: 49.5,
        p95: 50.3,
        p97: 50.7,
        p99: 51.3,
      },
    },
    {
      age: 24,
      m: 48.2515,
      s: 0.02821,
      sd: 1.3612,
      percentiles: {
        p1: 45.1,
        p3: 45.7,
        p5: 46,
        p15: 46.8,
        p25: 47.3,
        p50: 48.3,
        p75: 49.2,
        p85: 49.7,
        p95: 50.5,
        p97: 50.8,
        p99: 51.4,
      },
    },
    {
      age: 25,
      m: 48.3777,
      s: 0.02825,
      sd: 1.3667,
      percentiles: {
        p1: 45.2,
        p3: 45.8,
        p5: 46.1,
        p15: 47,
        p25: 47.5,
        p50: 48.4,
        p75: 49.3,
        p85: 49.8,
        p95: 50.6,
        p97: 50.9,
        p99: 51.6,
      },
    },
    {
      age: 26,
      m: 48.4989,
      s: 0.0283,
      sd: 1.3725,
      percentiles: {
        p1: 45.3,
        p3: 45.9,
        p5: 46.2,
        p15: 47.1,
        p25: 47.6,
        p50: 48.5,
        p75: 49.4,
        p85: 49.9,
        p95: 50.8,
        p97: 51.1,
        p99: 51.7,
      },
    },
    {
      age: 27,
      m: 48.6151,
      s: 0.02834,
      sd: 1.3778,
      percentiles: {
        p1: 45.4,
        p3: 46,
        p5: 46.3,
        p15: 47.2,
        p25: 47.7,
        p50: 48.6,
        p75: 49.5,
        p85: 50,
        p95: 50.9,
        p97: 51.2,
        p99: 51.8,
      },
    },
    {
      age: 28,
      m: 48.7264,
      s: 0.02838,
      sd: 1.3829,
      percentiles: {
        p1: 45.5,
        p3: 46.1,
        p5: 46.5,
        p15: 47.3,
        p25: 47.8,
        p50: 48.7,
        p75: 49.7,
        p85: 50.2,
        p95: 51,
        p97: 51.3,
        p99: 51.9,
      },
    },
    {
      age: 29,
      m: 48.8331,
      s: 0.02842,
      sd: 1.3878,
      percentiles: {
        p1: 45.6,
        p3: 46.2,
        p5: 46.6,
        p15: 47.4,
        p25: 47.9,
        p50: 48.8,
        p75: 49.8,
        p85: 50.3,
        p95: 51.1,
        p97: 51.4,
        p99: 52.1,
      },
    },
    {
      age: 30,
      m: 48.9351,
      s: 0.02847,
      sd: 1.3932,
      percentiles: {
        p1: 45.7,
        p3: 46.3,
        p5: 46.6,
        p15: 47.5,
        p25: 48,
        p50: 48.9,
        p75: 49.9,
        p85: 50.4,
        p95: 51.2,
        p97: 51.6,
        p99: 52.2,
      },
    },
    {
      age: 31,
      m: 49.0327,
      s: 0.02851,
      sd: 1.3979,
      percentiles: {
        p1: 45.8,
        p3: 46.4,
        p5: 46.7,
        p15: 47.6,
        p25: 48.1,
        p50: 49,
        p75: 50,
        p85: 50.5,
        p95: 51.3,
        p97: 51.7,
        p99: 52.3,
      },
    },
    {
      age: 32,
      m: 49.126,
      s: 0.02855,
      sd: 1.4026,
      percentiles: {
        p1: 45.9,
        p3: 46.5,
        p5: 46.8,
        p15: 47.7,
        p25: 48.2,
        p50: 49.1,
        p75: 50.1,
        p85: 50.6,
        p95: 51.4,
        p97: 51.8,
        p99: 52.4,
      },
    },
    {
      age: 33,
      m: 49.2153,
      s: 0.02859,
      sd: 1.4071,
      percentiles: {
        p1: 45.9,
        p3: 46.6,
        p5: 46.9,
        p15: 47.8,
        p25: 48.3,
        p50: 49.2,
        p75: 50.2,
        p85: 50.7,
        p95: 51.5,
        p97: 51.9,
        p99: 52.5,
      },
    },
    {
      age: 34,
      m: 49.3007,
      s: 0.02863,
      sd: 1.4115,
      percentiles: {
        p1: 46,
        p3: 46.6,
        p5: 47,
        p15: 47.8,
        p25: 48.3,
        p50: 49.3,
        p75: 50.3,
        p85: 50.8,
        p95: 51.6,
        p97: 52,
        p99: 52.6,
      },
    },
    {
      age: 35,
      m: 49.3826,
      s: 0.02867,
      sd: 1.4158,
      percentiles: {
        p1: 46.1,
        p3: 46.7,
        p5: 47.1,
        p15: 47.9,
        p25: 48.4,
        p50: 49.4,
        p75: 50.3,
        p85: 50.8,
        p95: 51.7,
        p97: 52,
        p99: 52.7,
      },
    },
    {
      age: 36,
      m: 49.4612,
      s: 0.02871,
      sd: 1.42,
      percentiles: {
        p1: 46.2,
        p3: 46.8,
        p5: 47.1,
        p15: 48,
        p25: 48.5,
        p50: 49.5,
        p75: 50.4,
        p85: 50.9,
        p95: 51.8,
        p97: 52.1,
        p99: 52.8,
      },
    },
    {
      age: 37,
      m: 49.5367,
      s: 0.02875,
      sd: 1.4242,
      percentiles: {
        p1: 46.2,
        p3: 46.9,
        p5: 47.2,
        p15: 48.1,
        p25: 48.6,
        p50: 49.5,
        p75: 50.5,
        p85: 51,
        p95: 51.9,
        p97: 52.2,
        p99: 52.8,
      },
    },
    {
      age: 38,
      m: 49.6093,
      s: 0.02878,
      sd: 1.4278,
      percentiles: {
        p1: 46.3,
        p3: 46.9,
        p5: 47.3,
        p15: 48.1,
        p25: 48.6,
        p50: 49.6,
        p75: 50.6,
        p85: 51.1,
        p95: 52,
        p97: 52.3,
        p99: 52.9,
      },
    },
    {
      age: 39,
      m: 49.6791,
      s: 0.02882,
      sd: 1.4318,
      percentiles: {
        p1: 46.3,
        p3: 47,
        p5: 47.3,
        p15: 48.2,
        p25: 48.7,
        p50: 49.7,
        p75: 50.6,
        p85: 51.2,
        p95: 52,
        p97: 52.4,
        p99: 53,
      },
    },
    {
      age: 40,
      m: 49.7465,
      s: 0.02886,
      sd: 1.4357,
      percentiles: {
        p1: 46.4,
        p3: 47,
        p5: 47.4,
        p15: 48.3,
        p25: 48.8,
        p50: 49.7,
        p75: 50.7,
        p85: 51.2,
        p95: 52.1,
        p97: 52.4,
        p99: 53.1,
      },
    },
    {
      age: 41,
      m: 49.8116,
      s: 0.02889,
      sd: 1.4391,
      percentiles: {
        p1: 46.5,
        p3: 47.1,
        p5: 47.4,
        p15: 48.3,
        p25: 48.8,
        p50: 49.8,
        p75: 50.8,
        p85: 51.3,
        p95: 52.2,
        p97: 52.5,
        p99: 53.2,
      },
    },
    {
      age: 42,
      m: 49.8745,
      s: 0.02893,
      sd: 1.4429,
      percentiles: {
        p1: 46.5,
        p3: 47.2,
        p5: 47.5,
        p15: 48.4,
        p25: 48.9,
        p50: 49.9,
        p75: 50.8,
        p85: 51.4,
        p95: 52.2,
        p97: 52.6,
        p99: 53.2,
      },
    },
    {
      age: 43,
      m: 49.9354,
      s: 0.02896,
      sd: 1.4461,
      percentiles: {
        p1: 46.6,
        p3: 47.2,
        p5: 47.6,
        p15: 48.4,
        p25: 49,
        p50: 49.9,
        p75: 50.9,
        p85: 51.4,
        p95: 52.3,
        p97: 52.7,
        p99: 53.3,
      },
    },
    {
      age: 44,
      m: 49.9942,
      s: 0.02899,
      sd: 1.4493,
      percentiles: {
        p1: 46.6,
        p3: 47.3,
        p5: 47.6,
        p15: 48.5,
        p25: 49,
        p50: 50,
        p75: 51,
        p85: 51.5,
        p95: 52.4,
        p97: 52.7,
        p99: 53.4,
      },
    },
    {
      age: 45,
      m: 50.0512,
      s: 0.02903,
      sd: 1.453,
      percentiles: {
        p1: 46.7,
        p3: 47.3,
        p5: 47.7,
        p15: 48.5,
        p25: 49.1,
        p50: 50.1,
        p75: 51,
        p85: 51.6,
        p95: 52.4,
        p97: 52.8,
        p99: 53.4,
      },
    },
    {
      age: 46,
      m: 50.1064,
      s: 0.02906,
      sd: 1.4561,
      percentiles: {
        p1: 46.7,
        p3: 47.4,
        p5: 47.7,
        p15: 48.6,
        p25: 49.1,
        p50: 50.1,
        p75: 51.1,
        p85: 51.6,
        p95: 52.5,
        p97: 52.8,
        p99: 53.5,
      },
    },
    {
      age: 47,
      m: 50.1598,
      s: 0.02909,
      sd: 1.4592,
      percentiles: {
        p1: 46.8,
        p3: 47.4,
        p5: 47.8,
        p15: 48.6,
        p25: 49.2,
        p50: 50.2,
        p75: 51.1,
        p85: 51.7,
        p95: 52.6,
        p97: 52.9,
        p99: 53.6,
      },
    },
    {
      age: 48,
      m: 50.2115,
      s: 0.02912,
      sd: 1.4622,
      percentiles: {
        p1: 46.8,
        p3: 47.5,
        p5: 47.8,
        p15: 48.7,
        p25: 49.2,
        p50: 50.2,
        p75: 51.2,
        p85: 51.7,
        p95: 52.6,
        p97: 53,
        p99: 53.6,
      },
    },
    {
      age: 49,
      m: 50.2617,
      s: 0.02915,
      sd: 1.4651,
      percentiles: {
        p1: 46.9,
        p3: 47.5,
        p5: 47.9,
        p15: 48.7,
        p25: 49.3,
        p50: 50.3,
        p75: 51.2,
        p85: 51.8,
        p95: 52.7,
        p97: 53,
        p99: 53.7,
      },
    },
    {
      age: 50,
      m: 50.3105,
      s: 0.02918,
      sd: 1.4681,
      percentiles: {
        p1: 46.9,
        p3: 47.5,
        p5: 47.9,
        p15: 48.8,
        p25: 49.3,
        p50: 50.3,
        p75: 51.3,
        p85: 51.8,
        p95: 52.7,
        p97: 53.1,
        p99: 53.7,
      },
    },
    {
      age: 51,
      m: 50.3578,
      s: 0.02921,
      sd: 1.471,
      percentiles: {
        p1: 46.9,
        p3: 47.6,
        p5: 47.9,
        p15: 48.8,
        p25: 49.4,
        p50: 50.4,
        p75: 51.3,
        p85: 51.9,
        p95: 52.8,
        p97: 53.1,
        p99: 53.8,
      },
    },
    {
      age: 52,
      m: 50.4039,
      s: 0.02924,
      sd: 1.4738,
      percentiles: {
        p1: 47,
        p3: 47.6,
        p5: 48,
        p15: 48.9,
        p25: 49.4,
        p50: 50.4,
        p75: 51.4,
        p85: 51.9,
        p95: 52.8,
        p97: 53.2,
        p99: 53.8,
      },
    },
    {
      age: 53,
      m: 50.4488,
      s: 0.02927,
      sd: 1.4766,
      percentiles: {
        p1: 47,
        p3: 47.7,
        p5: 48,
        p15: 48.9,
        p25: 49.5,
        p50: 50.4,
        p75: 51.4,
        p85: 52,
        p95: 52.9,
        p97: 53.2,
        p99: 53.9,
      },
    },
    {
      age: 54,
      m: 50.4926,
      s: 0.02929,
      sd: 1.4789,
      percentiles: {
        p1: 47.1,
        p3: 47.7,
        p5: 48.1,
        p15: 49,
        p25: 49.5,
        p50: 50.5,
        p75: 51.5,
        p85: 52,
        p95: 52.9,
        p97: 53.3,
        p99: 53.9,
      },
    },
    {
      age: 55,
      m: 50.5354,
      s: 0.02932,
      sd: 1.4817,
      percentiles: {
        p1: 47.1,
        p3: 47.7,
        p5: 48.1,
        p15: 49,
        p25: 49.5,
        p50: 50.5,
        p75: 51.5,
        p85: 52.1,
        p95: 53,
        p97: 53.3,
        p99: 54,
      },
    },
    {
      age: 56,
      m: 50.5772,
      s: 0.02935,
      sd: 1.4844,
      percentiles: {
        p1: 47.1,
        p3: 47.8,
        p5: 48.1,
        p15: 49,
        p25: 49.6,
        p50: 50.6,
        p75: 51.6,
        p85: 52.1,
        p95: 53,
        p97: 53.4,
        p99: 54,
      },
    },
    {
      age: 57,
      m: 50.6183,
      s: 0.02938,
      sd: 1.4872,
      percentiles: {
        p1: 47.2,
        p3: 47.8,
        p5: 48.2,
        p15: 49.1,
        p25: 49.6,
        p50: 50.6,
        p75: 51.6,
        p85: 52.2,
        p95: 53.1,
        p97: 53.4,
        p99: 54.1,
      },
    },
    {
      age: 58,
      m: 50.6587,
      s: 0.0294,
      sd: 1.4894,
      percentiles: {
        p1: 47.2,
        p3: 47.9,
        p5: 48.2,
        p15: 49.1,
        p25: 49.7,
        p50: 50.7,
        p75: 51.7,
        p85: 52.2,
        p95: 53.1,
        p97: 53.5,
        p99: 54.1,
      },
    },
    {
      age: 59,
      m: 50.6984,
      s: 0.02943,
      sd: 1.4921,
      percentiles: {
        p1: 47.2,
        p3: 47.9,
        p5: 48.2,
        p15: 49.2,
        p25: 49.7,
        p50: 50.7,
        p75: 51.7,
        p85: 52.2,
        p95: 53.2,
        p97: 53.5,
        p99: 54.2,
      },
    },
    {
      age: 60,
      m: 50.7375,
      s: 0.02946,
      sd: 1.4947,
      percentiles: {
        p1: 47.3,
        p3: 47.9,
        p5: 48.3,
        p15: 49.2,
        p25: 49.7,
        p50: 50.7,
        p75: 51.7,
        p85: 52.3,
        p95: 53.2,
        p97: 53.5,
        p99: 54.2,
      },
    },
  ],
};

export const whoBoysHeadCircumferenceWeekly: GrowthDataSet = {
  id: 'who-boys-head-circumference-weekly-0-13',
  source: 'WHO',
  title: 'Head circumference-for-age',
  intervalType: 'week',
  gender: 'male',
  measurementType: 'head_circumference',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 34.4618,
      s: 0.03686,
      sd: 1.2703,
      percentiles: {
        p1: 31.5,
        p3: 32.1,
        p5: 32.4,
        p15: 33.1,
        p25: 33.6,
        p50: 34.5,
        p75: 35.3,
        p85: 35.8,
        p95: 36.6,
        p97: 36.9,
        p99: 37.4,
      },
    },
    {
      age: 1,
      m: 35.1634,
      s: 0.03472,
      sd: 1.2209,
      percentiles: {
        p1: 32.3,
        p3: 32.9,
        p5: 33.2,
        p15: 33.9,
        p25: 34.3,
        p50: 35.2,
        p75: 36,
        p85: 36.4,
        p95: 37.2,
        p97: 37.5,
        p99: 38,
      },
    },
    {
      age: 2,
      m: 35.8649,
      s: 0.03258,
      sd: 1.1685,
      percentiles: {
        p1: 33.1,
        p3: 33.7,
        p5: 33.9,
        p15: 34.7,
        p25: 35.1,
        p50: 35.9,
        p75: 36.7,
        p85: 37.1,
        p95: 37.8,
        p97: 38.1,
        p99: 38.6,
      },
    },
    {
      age: 3,
      m: 36.5216,
      s: 0.03197,
      sd: 1.1676,
      percentiles: {
        p1: 33.8,
        p3: 34.3,
        p5: 34.6,
        p15: 35.3,
        p25: 35.7,
        p50: 36.5,
        p75: 37.3,
        p85: 37.7,
        p95: 38.4,
        p97: 38.7,
        p99: 39.2,
      },
    },
    {
      age: 4,
      m: 37.0926,
      s: 0.03148,
      sd: 1.1677,
      percentiles: {
        p1: 34.4,
        p3: 34.9,
        p5: 35.2,
        p15: 35.9,
        p25: 36.3,
        p50: 37.1,
        p75: 37.9,
        p85: 38.3,
        p95: 39,
        p97: 39.3,
        p99: 39.8,
      },
    },
    {
      age: 5,
      m: 37.601,
      s: 0.03107,
      sd: 1.1683,
      percentiles: {
        p1: 34.9,
        p3: 35.4,
        p5: 35.7,
        p15: 36.4,
        p25: 36.8,
        p50: 37.6,
        p75: 38.4,
        p85: 38.8,
        p95: 39.5,
        p97: 39.8,
        p99: 40.3,
      },
    },
    {
      age: 6,
      m: 38.0609,
      s: 0.03072,
      sd: 1.1692,
      percentiles: {
        p1: 35.3,
        p3: 35.9,
        p5: 36.1,
        p15: 36.8,
        p25: 37.3,
        p50: 38.1,
        p75: 38.8,
        p85: 39.3,
        p95: 40,
        p97: 40.3,
        p99: 40.8,
      },
    },
    {
      age: 7,
      m: 38.4824,
      s: 0.03041,
      sd: 1.1703,
      percentiles: {
        p1: 35.8,
        p3: 36.3,
        p5: 36.6,
        p15: 37.3,
        p25: 37.7,
        p50: 38.5,
        p75: 39.3,
        p85: 39.7,
        p95: 40.4,
        p97: 40.7,
        p99: 41.2,
      },
    },
    {
      age: 8,
      m: 38.8724,
      s: 0.03014,
      sd: 1.1716,
      percentiles: {
        p1: 36.1,
        p3: 36.7,
        p5: 36.9,
        p15: 37.7,
        p25: 38.1,
        p50: 38.9,
        p75: 39.7,
        p85: 40.1,
        p95: 40.8,
        p97: 41.1,
        p99: 41.6,
      },
    },
    {
      age: 9,
      m: 39.2368,
      s: 0.0299,
      sd: 1.1732,
      percentiles: {
        p1: 36.5,
        p3: 37,
        p5: 37.3,
        p15: 38,
        p25: 38.4,
        p50: 39.2,
        p75: 40,
        p85: 40.5,
        p95: 41.2,
        p97: 41.4,
        p99: 42,
      },
    },
    {
      age: 10,
      m: 39.5797,
      s: 0.02969,
      sd: 1.1751,
      percentiles: {
        p1: 36.8,
        p3: 37.4,
        p5: 37.6,
        p15: 38.4,
        p25: 38.8,
        p50: 39.6,
        p75: 40.4,
        p85: 40.8,
        p95: 41.5,
        p97: 41.8,
        p99: 42.3,
      },
    },
    {
      age: 11,
      m: 39.9033,
      s: 0.0295,
      sd: 1.1772,
      percentiles: {
        p1: 37.2,
        p3: 37.7,
        p5: 38,
        p15: 38.7,
        p25: 39.1,
        p50: 39.9,
        p75: 40.7,
        p85: 41.1,
        p95: 41.8,
        p97: 42.1,
        p99: 42.6,
      },
    },
    {
      age: 12,
      m: 40.2096,
      s: 0.02933,
      sd: 1.1794,
      percentiles: {
        p1: 37.5,
        p3: 38,
        p5: 38.3,
        p15: 39,
        p25: 39.4,
        p50: 40.2,
        p75: 41,
        p85: 41.4,
        p95: 42.1,
        p97: 42.4,
        p99: 43,
      },
    },
    {
      age: 13,
      m: 40.5008,
      s: 0.02918,
      sd: 1.1818,
      percentiles: {
        p1: 37.8,
        p3: 38.3,
        p5: 38.6,
        p15: 39.3,
        p25: 39.7,
        p50: 40.5,
        p75: 41.3,
        p85: 41.7,
        p95: 42.4,
        p97: 42.7,
        p99: 43.3,
      },
    },
  ],
};
